<!-- G6 -->
<template>
  <a-modal
    :visible="showModal"
    :title="title"
    width="820px"
    class="public-del"
    centered
    :closable="false"
  >
    <div style="padding: 0px 0 0px 20px">
      <span>搜索地点:</span>
      <a-select
        autoFocus
        allowClear
        :showArrow="false"
        show-search
        v-model="selectName"
        placeholder="搜索区域名称"
        style="width: 300px; margin-right: 20px"
        :not-found-content="fetching ? undefined : null"
        :default-active-first-option="false"
        @search="fetchUser"
        @change="handleSelect"
        :getPopupContainer="getPopupContainer"
        defaultOpen
        :filter-option="false"
      >
        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
        <a-select-option
          :value="item.key"
          v-for="(item, index) in aeraList"
          :key="item.key"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
      <span>经纬度:{{ coordinates }}</span>
    </div>
    <div>
      <el-amap
        id="map"
        :events="events"
        vid="amap"
        :plugin="plugin"
        :zoom="zoom"
        :zoomEnable="zoomEnable"
        :dragEnable="dragEnable"
        :center="center"
        ref="map"
        class="amap-demo"
      >
        <el-amap-marker
          :visible="markerVisible"
          vid="amapmarker"
          :position="Markercenter"
          :events="handleMarker"
        ></el-amap-marker>
      </el-amap>
    </div>
    <template slot="footer">
      <a-button type="primary" @click="Fun_ok" style="margin-left: 16px"
        >确定</a-button
      >
      <a-button style="margin-left: 16px" @click="Fun_cancel">取消</a-button>
    </template>
  </a-modal>
</template>

<script>
import axios from "axios";
import AMap from "vue-amap";
// import { getGaoDe } from "@/services/map";
export default {
  name: "MapModal",
  props: {
    showModal: { require: false, type: Boolean },
    modalArr: { require: false }
  },
  data() {
    return {
      title: "地图",
      isShow: true,
      amapManager: "",
      selectName: "",
      addressName: "",
      fetching: false,
      coordinates: "", // 经纬度
      aeraList: [], // 搜索区域
      center: [108.95, 34.27], // 西安
      markerVisible: false, // 标记
      Markercenter: [108.95, 34.27],
      zoom: 12,
      events: {
        init: o => {
          o.getCity(result => {});
        },
        // 点击地图
        click: e => {
          this.handleclick(e);
        }
      },
      handleMarker: {
        // 点击Marker
        click: e => {
          this.handleclick(e);
        }
      },
      plugin: ["Scale", "OverView", "ToolBar", "PolyEditor", "Autocomplete"],
      zoomEnable: true, // 地图是否可缩放
      dragEnable: true, // 通过鼠标拖动
      timer: null // 倒计时0.4秒后  执行地图列表搜索
    };
  },
  watch: {},
  async mounted() {
    this.selectName = "";
    // 生命周期-挂载完成(可以访问DOM元素)
    this.amapManager = new AMap.AMapManager();
    if (this.modalArr.coordinates) {
      this.coordinates = this.modalArr.coordinates;
      this.markerVisible = true;
      let lng = this.modalArr.coordinates.split(",")[0];
      let lat = this.modalArr.coordinates.split(",")[1];
      this.center = [JSON.parse(lng), JSON.parse(lat)];
      this.Markercenter = [JSON.parse(lng), JSON.parse(lat)];
    }
    if (this.modalArr.detailedAddressValue) {
      this.selectName = this.modalArr.detailedAddressValue;
      await this.fetchUser(this.modalArr.detailedAddressValue, "true");
    }
  },
  destroyed() {
    clearTimeout(this.timer);
    // 生命周期-销毁完成
  },
  activated() {
    // 如果页面有keep-alive缓存功能，这个函数会触发
  },
  methods: {
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode;
    },
    // 地图点击
    handleclick(e) {
      this.aeraList = [];
      let q = e.lnglat.lat;
      let r = e.lnglat.lng;
      this.markerVisible = true;
      // this.center = [JSON.parse(q), JSON.parse(r)]
      this.Markercenter = [JSON.parse(r), JSON.parse(q)];
      this.coordinates = this.Markercenter[0] + "," + this.Markercenter[1];
    },
    // 地图搜索
    async fetchUser(val, first = "false") {
      this.aeraList = [];
      this.fetching = true;
      if (first === "true") {
        this.timer = setTimeout(async () => {
          this.aeraList = await this.epcNameListSer(val);
        }, 400);
      } else {
        this.aeraList = await this.epcNameListSer(val);
      }
      // console.log(this.aeraList, "this.aeraList");
      this.fetching = false;
    },
    // 接口
    async epcNameListSer(keywords) {
      let res = await axios({
        url: "/mapUrl",
        method: "GET",
        params: {
          key: this.$mapKey, // 公司注册的高德web服务key
          keywords,
          city: "陕西",
          citylimit: true
        }
      });
      if (res.status == 1) {
        let data = res.tips.filter((v, index) => {
          // 只需要有经纬度,name值的
          if (
            v.location &&
            v.location.length > 0 &&
            v.name &&
            v.name.length > 0
          ) {
            v.key = v.name + index;
            return v;
          }
        });
        return data;
      }
    },
    // async epcNameListSer(keywords) {
    //   let res = await getGaoDe({
    //     mapKey: this.$mapKey,
    //     keywords,
    //   });
    //   if (res.status == 1) {
    //     let data = res.tips.filter((v) => {
    //       // 只需要有经纬度的
    //       if (v.location && v.location.length > 0) {
    //         return v;
    //       }
    //     });
    //     return data;
    //   }
    // },
    // 下拉框点击
    handleSelect(value) {
      // console.log(value, "value");
      if (
        value === undefined ||
        this.aeraList === undefined ||
        this.aeraList === null ||
        this.aeraList.length === 0
      ) {
        return;
      }
      let val = this.aeraList.find((item, index) => {
        return item.name + index === value;
      });
      this.coordinates = val.location;
      this.selectName = val.name;
      // this.addressName = val.name;
      let opt = val.location.split(",");
      this.center = [JSON.parse(opt[0]), JSON.parse(opt[1])];
      this.markerVisible = true;
      this.Markercenter = this.center;
      this.zoom = 16;
    },
    // 取消
    Fun_cancel() {
      this.$emit("cancel");
    },
    // 确定
    Fun_ok() {
      if (this.coordinates) {
        this.$emit("Ok", {
          coordinates: this.coordinates || "",
          // addressName: this.addressName,
          addressName: this.selectName
        });
      } else {
        this.$message.warning("请选择经纬度");
      }
    }
  }
};
</script>
<style lang="less">
//@import url(); 引入公共css类
</style>
<style lang="less" scoped>
/deep/.ant-modal-body {
  min-height: 530px;
}
.public-del {
  min-height: 600px;
}
//@import url(); 引入公共css类
#map {
  height: 500px;
  padding: 20px;
}
</style>
